import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import EmojiTextarea from './EmojiTextarea';

function formatDate(iso) {
  if (!iso) return '';
  return iso.replace('T', ' ').slice(0, 16);
}

export default function CommentThread({ comment, depth = 0, onReply, onEdit, onDelete }) {
  const { user } = useAuth();
  const [replying, setReplying] = useState(false);
  const [replyText, setReplyText] = useState('');
  const [editing, setEditing] = useState(false);
  const [editText, setEditText] = useState(comment.content);
  const canManage = user?.teachid === comment.teachid || user?.role === 'admin' || user?.role === 'staff';

  const submitReply = async () => {
    if (!replyText.trim()) return;
    await onReply(comment.commentid, replyText.trim());
    setReplyText('');
    setReplying(false);
  };

  const submitEdit = async () => {
    if (!editText.trim()) return;
    await onEdit(comment.commentid, editText.trim());
    setEditing(false);
  };

  return (
    <div className="comment" style={{ marginLeft: depth * 24 }}>
      <div className="comment-head">
        <span className="comment-author">{comment.author_name}</span>
        <span className="comment-date">{formatDate(comment.createat)}</span>
      </div>

      {editing ? (
        <div className="comment-edit">
          <EmojiTextarea value={editText} onChange={setEditText} rows={2} />
          <div className="comment-actions">
            <button className="btn-ghost" onClick={submitEdit}>저장</button>
            <button className="btn-ghost" onClick={() => setEditing(false)}>취소</button>
          </div>
        </div>
      ) : (
        <div className="comment-body">{comment.content}</div>
      )}

      <div className="comment-actions">
        <button className="btn-link" onClick={() => setReplying((v) => !v)}>답글</button>
        {canManage && !editing && (
          <>
            <button className="btn-link" onClick={() => setEditing(true)}>수정</button>
            <button className="btn-link" onClick={() => onDelete(comment.commentid)}>삭제</button>
          </>
        )}
      </div>

      {replying && (
        <div className="comment-reply-form">
          <EmojiTextarea
            value={replyText}
            onChange={setReplyText}
            rows={2}
            placeholder="답글을 입력하세요"
          />
          <div className="comment-actions">
            <button className="btn-ghost" onClick={submitReply}>등록</button>
            <button className="btn-ghost" onClick={() => setReplying(false)}>취소</button>
          </div>
        </div>
      )}

      {comment.replies?.map((r) => (
        <CommentThread
          key={r.commentid}
          comment={r}
          depth={depth + 1}
          onReply={onReply}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
